<template>
  <tr
    :class="{ 'subtotal-row': item.isSubtotal }"
    :data-divider="item.isDivider"
    :data-task-start="item.isTaskStart"
  >
    <td v-if="item.isSubtotal">{{ item.task }}</td>
    <td v-else-if="item.isTaskStart" :rowspan="item.taskRowspan">{{ item.task }}</td>
    <td v-else style="display: none;"></td>
    <td v-if="item.isSubtotal"></td>
    <td v-else-if="item.isRoleStart" :rowspan="item.roleRowspan">{{ item.role }}</td>
    <td v-else style="display: none;"></td>
    <td>{{ item.description }}</td>
    <td v-if="item.isSubtotal"></td>
    <td v-else>{{ item.employee }}</td>
    <td v-if="item.isSubtotal">{{ item.estimation }}h</td>
    <td v-else-if="item.isRoleStart" :rowspan="item.roleRowspan">{{ item.estimation }}h</td>
    <td v-else style="display: none;"></td>
    <td>{{ (item.total / 60).toFixed(2) }}h</td>
    <td>{{ item.cost }}</td>
  </tr>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'BudgetTrackerTableRow',
  props: {
    item: {
      type: Object,
      required: true,
    },
    headers: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isEditing: false,
    };
  },
  computed: {
    ...mapGetters('reports/summary', ['isSummaryEditing']),
    ...mapGetters('reports/main', [
      'isReportEditable',
      'isProjectManagerOfReport',
      'isReportOfficeMatching',
    ]),
  },
  methods: {
    ...mapActions('reports/summary', [
      'setIsSummaryEditing',
      'updateSummaryReportUnit',
      'getSummary',
    ]),
    ...mapActions('reports/units', [
      'getReportUnits',
      'setReportUnits',
    ]),

    setEditing(value) {
      this.isEditing = value;
      this.setIsSummaryEditing(value);
    },

    editSummaryReportUnit() {
      if (!this.isReportEditable || this.isSummaryEditing) return;

      this.setEditing(true);
    },
    updateSummaryUnit(summaryUnit) {
      this.updateSummaryReportUnit(summaryUnit);
      this.setEditing(false);
    },
    cancelSummaryReportUnitEditing() {
      this.setEditing(false);
    },

    regenerateRow() {
      this.$emit('onRegenerate', this.item);
    },

    deleteRow() {
      this.$emit('onDelete', this.item);
    },

    calculateTableClass(column, item) {
      if (column !== 'regular_time') return 'text-start';

      const invoicedTime = item.regular_time + item.non_working_time;

      return invoicedTime < item.expected_time ? ['text-start', 'red', 'lighten-3'] : 'text-start';
    },
    isOverLimit(column, item) {
      if (column !== 'employee.name') {
        return '';
      }

      const findMatchedEmployeeWithItem = this.reportUnits.find((el) => el.employee.id === item.employee.id && el.over_limit);

      if (findMatchedEmployeeWithItem) {
        return 'amber lighten-4';
      }

      return '';
    },
  },
};
</script>

<style lang="less" scoped>
@import "~variables";

.subtotal-row {
  background-color: #f5f5f5;
  font-weight: bold;
}

.mb-2 {
  margin-bottom: 8px;
}

.ml-4 {
  margin-left: 16px;
}
</style>
